angular.module('account.settings.social.twitter', ['security']);
angular.module('account.settings.social.twitter').config(['$routeProvider', function($routeProvider){
  $routeProvider
    .when('/account/settings/twitter/callback', {
      resolve: {
        connect: ['$log', '$q', '$location', '$route', 'security', function($log, $q, $location, $route, security){
          var params = $route.current.params;
          var search = {};
          var promise = security.socialConnect('twitter', params)
            .then(function(data){
              if(data.success){
                search.success = 'true';
              }else{
                search.success = 'false';
                search.reason = data.errors[0];
              }
              return $q.reject();
            })
            .catch(function(){
              search.provider = 'twitter';
              search.success = search.success || 'false';
              $location.search({}); //remove search param "code" added by twitter
              $location.search(search);
              $location.path('/account/settings');
              return $q.reject();
            });
          return promise;
        }]
      },
      reloadOnSearch: false
    });
}]);



// WEBPACK FOOTER //
// ./client/src/app/account/settings/social/connect-twitter.js